import Service from '../notice-modular-service';
import Pagination from '@/components/pagination/index.vue';
export default {
  components: {
    Pagination
  },
  data () {
    return {
      total: 0,
      tableList: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        gorAndgageName: ''
      },
      mortgageType: {
        'CODE1': '土地经营权',
        'CODE2': '林权',
        'CODE3': '生物资产',
        'CODE4': '生产设施所有权',
        'CODE5': '房屋',
        'CODE6': '宅基地'
      },
      mortStatus: {
        'STATUS1': '抵押中',
        'STATUS2': '已到期',
        'STATUS3': '提前解押'
      }
    };
  },
  created () {
    // Service.getGovAssetDict('CODE');
    this.getTableList();
  },
  computed: {
  },
  methods: {
    resetQuery() {
      this.searchForm.gorAndgageName = '';
      this.getTableList();
    },
    // 获取交易公示列表
    getTableList (page) {
      this.tableList = [];
      if (page) {
        // this.searchForm.projectType = this.searchForm.projectType;
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 10;
      }
      Service.getMortgageList(this.searchForm).then(res => {
        if (res && res.code === 0) {
          this.tableList = res.data.records;
          this.total = Number(res.data.total);
        }
      });
    },

    handdle(row) {
      this.$router.push('/notice-modular/mortgage-detail?id=' + row.id);
    }
  }
};
